"use client"
import { useChains } from "@opensea/app-kit"
import type { ChainIdentifier } from "@opensea/graphql"
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs"
import { QUERY_PARAM_KEYS } from "./keys"

export const useChainParser = () => {
  const { chains } = useChains()
  return parseAsStringLiteral(chains.map(c => c.identifier))
}

export function useChainsQueryParam({
  shallow = true,
}: {
  shallow?: boolean
} = {}) {
  const parser = useChainParser()
  const [values, setValues] = useQueryState(
    QUERY_PARAM_KEYS.chains,
    parseAsArrayOf(parser).withOptions({ shallow }).withDefault([]),
  )

  async function onSelectChain(value: ChainIdentifier) {
    const newValues = values.includes(value)
      ? values.filter(c => c !== value)
      : [...values, value]

    await setValues(newValues.length > 0 ? newValues : null)
  }

  async function setChains(chains: ChainIdentifier[] | null) {
    await setValues(chains)
  }

  return {
    chain: values[0],
    chains: values,
    onSelectChain,
    setChains,
  }
}
